import Hero from './Hero';
import MovieCard from './MovieCard';
import { useNavigate } from 'react-router-dom';

//movie is the movie object, the prop is passed at line 49
const SearchView = ({ keyword, searchResults }) => {
	let title = `You are searching for ${keyword}`;
	const navigate = useNavigate();

	if (keyword && searchResults.length <= 0) {
		title = `Sorry, there are no search results for ${keyword}`;
	}

	//filter the resuts by language
	let results = searchResults.filter(item => {
		return item.original_language.toLowerCase() === 'en';
	});

	//set search results to new filtered array
	searchResults = results;

	// loop through search results and display each movie title from the search results in a div
	const resultsHTML = searchResults.map((obj, i) => {
		//if the search bar has data and the images are available, show results
		if (keyword) {
			if (obj.poster_path) {
				return <MovieCard movie={obj} key={i} />;
			}
		} else {
			//re-reroute to home
			navigate('/');
		}
	});

	return (
		<div>
			<Hero text={title} />
			{/* run the loop and display the search results on the page */}
			{resultsHTML && (
				<div className='container'>
					<div className='row'>{resultsHTML}</div>
				</div>
			)}
		</div>
	);
};

export default SearchView;
